// stores/useTermsStore.js
import { create } from "zustand";

const useTermsStore = create((set, get) => ({
  termsMap: {},

  setTerms: (termsList) => {
    console.log("setTerms called with →", termsList);
    const map = (termsList ?? []).reduce((acc, item) => {
      acc[item.document_type] = { id: item.id, content: item.content };
      return acc;
    }, {});
    console.log("termsMap built →", map);
    set({ termsMap: map });
  },

  getTerms: (document_type) => get().termsMap[document_type] ?? null,

  clearTerms: () => set({ termsMap: {} }),
}));

export default useTermsStore;
